export default "__VITE_ASSET__UrvM97Ys__"